import { AxiosResponse } from "axios";
import { BASE_METHODS } from "../../constants/action-types";
import {
  addPushMessageToPushMessages,
  setPushMessageActionStart,
  setPushMessageErrorMessage,
} from "../../constants/reducers/push-message.reducer";
import { store } from "../../store";
import { createCall } from "../base";
import { CreatePushMessageDTO } from "../../constants/dto/push-message";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";

let requestBody: CreatePushMessageDTO;

export function formatBackendDate(dateString: string) {
  const date = new Date(dateString);

  return date.toISOString();
}

export const createPushMessage = async () => {
  store.dispatch(setPushMessageActionStart(true));
  const { title, body, immediate, sendDate, sendTime } =
    store.getState().pushMessage;

  const request = await createCall(
    "cms/push-messages/create",
    BASE_METHODS.POST,
    "application/json",
    "1.0.0",
    {
      title,
      description: body,
      immediate,
      sendDate: formatBackendDate(`${sendDate}T${sendTime}:00`),
    },
    undefined,
  );

  try {
    const response = request as AxiosResponse;
    requestBody = plainToClass(CreatePushMessageDTO, response.data);
    const errors = await validate(requestBody);
    if (errors.length > 0) {
      store.dispatch(
        setPushMessageErrorMessage(
          TextEnum.CREATE_PUSH_MESSAGE_INVALID_RESPONSE,
        ),
      );
      return;
    }
    store.dispatch(
      addPushMessageToPushMessages({ pushMessage: response.data.pushMessage }),
    );
    return response;
  } catch (error) {
    store.dispatch(setPushMessageActionStart(false));
    store.dispatch(timeoutError());
    return;
  }
};
